import React from "react";
import { ScrollView } from "react-native";

export default props => {
    const _handleRef = ref => {
        let _rnkasv_keyboardView = ref;
        if (props.innerRef) {
            props.innerRef(_rnkasv_keyboardView);
        }
        if (props.ref) {
            props.ref(_rnkasv_keyboardView);
        }
    };

    return (
        <ScrollView {...props} ref={_handleRef}>
            {props.children}
        </ScrollView>
    );
};
